import { Box, Grid } from "@mui/material";
//import from projects
import "./dashboard.scss";
import HeaderCard from "../../Components/Dashboard/HeaderCard";
// import TotalAttendance from "../../Components/Dashboard/TotalAttendance";
import TotalStudentDropout from "../../Components/Dashboard/TotalStudentDropout";
// import TotalStudentByGender from "../../Components/Dashboard/TotalStudentByGender";
import TotalRevenueByType from "../../Components/Dashboard/TotalRevenueByType";
import StudentCompleteClass from "../../Components/Dashboard/StudentCompleteClass";
import StudentDropout from "../../Components/Dashboard/StudentDropout";
// import StudentTbale from "../../Components/Dashboard/StudentTbale";
import TeacherBySchedule from "../../Components/Dashboard/TeacherBySchedule";
import TeacherBirthday from "../../Components/Dashboard/TeacherBirthday";
import TotalIncomeGraph from "../../Components/Dashboard/TotalIncomeGraph";

export default function Dashboard() {
  return (
    <div className="dashboard-page">
      <Box className="body-container">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <HeaderCard />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TotalRevenueByType />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TotalIncomeGraph />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={5} xl={3}>
            <StudentCompleteClass />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={5} xl={3}>
            <StudentDropout />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TotalStudentDropout />
          </Grid>

          {/* <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
            <TotalStudentByGender />
          </Grid> */}

          <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
            <TeacherBySchedule />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
            <TeacherBirthday />
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <StudentCompleteClass />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <StudentCompleteClass />
          </Grid> */}
        </Grid>
      </Box>
    </div>
  );
}
